export enum ProductFormFieldNames {
  Label = 'label',
  Code = 'code',
  Summary = 'summary',
  FullDescription = 'fullDescription',
  Logo = 'logo',
  BranchId = 'branchId',
  PersonId = 'personId',
  IsTacitRenewal = 'isTacitRenewal',
  IsFixedFormula = 'isFixedFormula',
  TargetedSubscriber = 'targetedSubscriber',
  PlateformeIds = 'plateformeIds',
  NoticePeriodDuration = 'noticePeriodDuration',
}
